// angular
import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { ReCaptchaV3Service } from 'ng-recaptcha';
// services
import { StorageService } from './storage.service';
// types
import { RecaptchaData } from '../types/recaptcha-data.type';

@Injectable()
export class RecaptchaService {
  // states
  public recaptchaData = signal<RecaptchaData | null>(null);

  // dependencies
  private readonly _httpClient = inject(HttpClient);
  private readonly _recaptchaV3Service = inject(ReCaptchaV3Service);
  private readonly _storageService = inject(StorageService);

  constructor() {}

  private _verifyRecaptchaToken(token: string) {
    return this._httpClient.post<RecaptchaData>(`main/verify-captcha`, {
      token,
    });
  }

  public recaptchaValidation(action: string = 'form action') {
    this._recaptchaV3Service.execute(action).subscribe(token => {
      const lastToken = this._storageService.getReCaptchaToken();

      if (lastToken) {
        const challengeTimestamp = new Date(lastToken.challenge_ts);
        const now = new Date();
        // check token is valid
        // change to milliseconds
        const tokenValidDuration = 2 * 60 * 1000;

        if (now.getTime() - challengeTimestamp.getTime() < tokenValidDuration) {
          // update storage and skip revalidation
          this.recaptchaData.set(lastToken);
          return;
        }
      } else {
        this._storageService.setReCaptchaToken(token);

        this._verifyRecaptchaToken(token).subscribe({
          next: res => {
            this.recaptchaData.set(res);
          },
        });
      }
    });
  }
}
